import { Component, OnInit, OnDestroy, HostListener, Input, inject } from '@angular/core';
import { Provider } from 'app/core/models/provider.model';
import { NavComponent } from 'app/shared/components/nav/nav.component';
import { UserPresenceService } from 'app/core/services/user-presence.service';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { UserPresenceComponent } from '../../../shared/components/user-presence/user-presence.component';
const userPresenceKey = 'provider';

@Component({
    selector: 'app-provider-nav',
    templateUrl: './provider-nav.component.html',
    styleUrls: ['./provider-nav.component.scss'],
    imports: [RouterLinkActive, RouterLink, UserPresenceComponent]
})
export class ProviderNavComponent extends NavComponent implements OnInit, OnDestroy {
  private userPresenceService = inject(UserPresenceService);

  @Input() provider: Provider;

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(): void {
    this.leaveAndUnsubscribe();
  }

  ngOnInit() {
    this.subscribeAndJoin();
  }

  ngOnDestroy(): void {
    this.leaveAndUnsubscribe();
  }

  private subscribeAndJoin() {
    this.userPresenceService.subscribeAndJoin(userPresenceKey, this.provider.id);
  }

  private leaveAndUnsubscribe() {
    this.userPresenceService.leaveAndUnsubscribe(userPresenceKey, this.provider.id);
  }
}
